var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_vm.form.filters.analitico ? _c('div', [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Origem",
      "dense": "",
      "outlined": "",
      "item-text": function (v) {
        return v.nome.toUpperCase();
      },
      "item-value": "id",
      "items": _vm.form.lists.origens
    },
    model: {
      value: _vm.form.filters.origemAnalitico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "origemAnalitico", $$v);
      },
      expression: "form.filters.origemAnalitico"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.form.lists.listaSetores,
      "label": "Setor",
      "item-text": "nome",
      "item-value": "id",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.setorAnalitico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "setorAnalitico", $$v);
      },
      expression: "form.filters.setorAnalitico"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Função",
      "outlined": "",
      "dense": "",
      "items": _vm.form.lists.listaFuncoes,
      "item-text": "nome",
      "item-value": "id"
    },
    model: {
      value: _vm.form.filters.funcaoAnalitico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "funcaoAnalitico", $$v);
      },
      expression: "form.filters.funcaoAnalitico"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Formação",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.formacaoAnalitico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "formacaoAnalitico", $$v);
      },
      expression: "form.filters.formacaoAnalitico"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('sigfoco-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data Início",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataInicioAnalitico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataInicioAnalitico", $$v);
      },
      expression: "form.filters.dataInicioAnalitico"
    }
  }), _c('sigfoco-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data Final",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataFimAnalitico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataFimAnalitico", $$v);
      },
      expression: "form.filters.dataFimAnalitico"
    }
  }), _c('sigfoco-select-ativo', {
    attrs: {
      "cols": 3,
      "labelType": "Situação"
    },
    model: {
      value: _vm.form.filters.situacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "situacao", $$v);
      },
      expression: "form.filters.situacao"
    }
  }), _c('sigfoco-switch-button', {
    attrs: {
      "cols": 2,
      "label": "Tipo de Relatório",
      "labelChecked": "Analítico",
      "labelUnchecked": "Sintético"
    },
    model: {
      value: _vm.form.filters.analitico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "analitico", $$v);
      },
      expression: "form.filters.analitico"
    }
  })], 1)], 1) : _c('div', [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.form.lists.listaSetores,
      "label": "Setor",
      "item-text": "nome",
      "item-value": "id",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.setorSintetico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "setorSintetico", $$v);
      },
      expression: "form.filters.setorSintetico"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Função",
      "outlined": "",
      "dense": "",
      "items": _vm.form.lists.listaFuncoes,
      "item-text": "nome",
      "item-value": "id"
    },
    model: {
      value: _vm.form.filters.funcaoSintetico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "funcaoSintetico", $$v);
      },
      expression: "form.filters.funcaoSintetico"
    }
  })], 1), _c('sigfoco-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data Início",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataInicioSintetico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataInicioSintetico", $$v);
      },
      expression: "form.filters.dataInicioSintetico"
    }
  }), _c('sigfoco-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data Final",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataFimSintetico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataFimSintetico", $$v);
      },
      expression: "form.filters.dataFimSintetico"
    }
  }), _c('sigfoco-switch-button', {
    attrs: {
      "cols": 2,
      "label": "Tipo de Relatório",
      "labelChecked": "Analítico",
      "labelUnchecked": "Sintético"
    },
    model: {
      value: _vm.form.filters.analitico,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "analitico", $$v);
      },
      expression: "form.filters.analitico"
    }
  })], 1)], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-tooltip', {
    attrs: {
      "text": "Buscar",
      "icon": "mdi-magnify"
    },
    on: {
      "click": _vm.buscarRelatorios
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": "Limpar",
      "icon": "mdi-eraser"
    },
    on: {
      "click": _vm.resetForm
    }
  })], 1)], 1)]), _vm.form.mostrarAnalitico ? _c('v-data-table', {
    staticClass: "mt-5 printable",
    attrs: {
      "headers": _vm.getFilteredHeader(_vm.headersAnalitico),
      "items": _vm.form.lists.listRelatorioAnalitico,
      "items-per-page": _vm.form.itemsPerPage,
      "footer-props": _vm.$footerProps,
      "expanded": _vm.expanded,
      "show-expand": "",
      "item-key": "formacaoId"
    },
    on: {
      "update:expanded": function ($event) {
        _vm.expanded = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: `item.origem`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.origem) + " ")];
      }
    }, {
      key: "expanded-item",
      fn: function (_ref2) {
        var headers = _ref2.headers,
          item = _ref2.item;
        return [_c('td', {
          staticClass: "setor",
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-chip-group', {
          attrs: {
            "active-class": "primary--text",
            "column": ""
          }
        }, _vm._l(item.setores, function (setor, i) {
          return _c('v-chip', {
            key: i,
            staticClass: "chip-permissao"
          }, [_vm._v(" " + _vm._s(setor.nome) + " ")]);
        }), 1)], 1)];
      }
    }, {
      key: `item.funcaoAnalitico`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(item.funcaoAnalitico) + " ")];
      }
    }, {
      key: `item.formacao`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(item.formacao) + " ")];
      }
    }, {
      key: `item.situacao`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('sigfoco-label-ativo-inativo', {
          attrs: {
            "ativo": item.situacao === 'Ativo'
          }
        })];
      }
    }], null, true)
  }) : _c('v-data-table', {
    staticClass: "mt-5 printable",
    attrs: {
      "headers": _vm.getFilteredHeader(_vm.headersSintetico),
      "items": _vm.form.lists.listRelatorioSintetico,
      "items-per-page": _vm.form.itemsPerPage,
      "footer-props": _vm.$footerProps,
      "expanded": _vm.expanded,
      "show-expand": "",
      "item-key": "funcaoId"
    },
    on: {
      "update:expanded": function ($event) {
        _vm.expanded = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "expanded-item",
      fn: function (_ref6) {
        var headers = _ref6.headers,
          item = _ref6.item;
        return [_c('td', {
          staticClass: "setor",
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-chip-group', {
          attrs: {
            "active-class": "primary--text",
            "column": ""
          }
        }, _vm._l(item.setores, function (setor, i) {
          return _c('v-chip', {
            key: i,
            staticClass: "chip-permissao"
          }, [_vm._v(" " + _vm._s(setor.nome) + " ")]);
        }), 1)], 1)];
      }
    }, {
      key: `item.setorSintetico`,
      fn: function (_ref7) {
        var item = _ref7.item;
        return [_vm._v(" " + _vm._s(item.setorSintetico) + " ")];
      }
    }, {
      key: `item.funcaoSintetico`,
      fn: function (_ref8) {
        var item = _ref8.item;
        return [_vm._v(" " + _vm._s(item.funcaoSintetico) + " ")];
      }
    }, {
      key: `item.qtdFormacoes`,
      fn: function (_ref9) {
        var item = _ref9.item;
        return [_vm._v(" " + _vm._s(item.qtdFormacoes) + " ")];
      }
    }, {
      key: `item.qtdPrevistas`,
      fn: function (_ref0) {
        var item = _ref0.item;
        return [_vm._v(" " + _vm._s(item.qtdPrevistas) + " ")];
      }
    }, {
      key: `item.qtdPresentes`,
      fn: function (_ref1) {
        var item = _ref1.item;
        return [_vm._v(" " + _vm._s(item.qtdPresentes) + " ")];
      }
    }, {
      key: `item.qtdAusentes`,
      fn: function (_ref10) {
        var item = _ref10.item;
        return [_vm._v(" " + _vm._s(item.qtdAusentes) + " ")];
      }
    }], null, true)
  }), _vm.form.lists.listRelatorioAnalitico.length > 0 || _vm.form.lists.listRelatorioSintetico.length > 0 ? _c('sigfoco-buttons', {
    attrs: {
      "actionText": "Baixar PDF",
      "cancelText": "Baixar CSV"
    },
    on: {
      "click": _vm.baixarRelatorioPdf,
      "cancel": _vm.baixarCSVRelatorio
    }
  }) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }